import { ChanelLandingPage } from "./pages/landing-page/chanel-landing-page";
import { ChanelEntryPage } from "./pages/entry/chanel-entry-page";
import { ChanelInvalidPage } from "./pages/invalid/chanel-invalid-page";

export const chanelCustomRoutes = [
  {
    path: "/landing-page",
    element: <ChanelLandingPage />,
  },
  {
    path: "/entry",
    element: <ChanelEntryPage />,
  },
  {
    path: "/invalid",
    element: <ChanelInvalidPage />,
  },
];
